// extracted by mini-css-extract-plugin
export default {"root":"MultiLineCellDouble_root__u1XYw","placeHolderShimmer":"MultiLineCellDouble_placeHolderShimmer__ScUQx"};